import { render } from "./ExServing.vue?vue&type=template&id=2e392684&scoped=true"
import script from "./ExServing.vue?vue&type=script&lang=js"
export * from "./ExServing.vue?vue&type=script&lang=js"

import "./ExServing.vue?vue&type=style&index=0&id=2e392684&lang=scss&scoped=true"

import exportComponent from "../../../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e392684"]])

export default __exports__